<div id="ht">
  <div id="main-cnt">
    <ion-header class="main-header block">
      <ion-toolbar class="blues-nav">
        <ion-buttons slot="start" class="nav-content">
          <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()">
              <span class="path1"></span>
              <span class="path2"></span>
            </span><ion-icon class="ion-padding-start" size="large" name="home" (click)="sessionService.gotoHome()"></ion-icon>
            <span class="breadcrumb">IMPOSTAZIONI</span>
          </div>
        </ion-buttons>
        <div slot="end" class="notification-div">
          <app-add-bookmark
            pageTitle="Impostazioni"
            url="/settings"
          ></app-add-bookmark>
          <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">
            <img [src]="sessionService?.user?.profileImg|s3Link" />

          </ion-avatar>
        </div>
      </ion-toolbar>
      <br />

      <!-- edit da qui... -->
      <h3 class="panel-title">Impostazioni</h3>
      <!-- ...a qui -->
    </ion-header>

    <ion-content class="main-content">
      <div class="scroller-container">
        <div class="content-scroller">
          <div class="content page-settings">
            <!-- edit da qui... -->

            <div class="flex-row">
              <div class="flex-1 text-left">Tema</div>
              <div class="flex-1 text-right">
                <ion-select
                  class="text-input"
                  name="role"
                  (ionChange)="changeTheme($event)"
                  [value]="sessionService.getTheme()"
                >
                  <ion-select-option
                    value="blue"
                    >Blu</ion-select-option
                  >
                  <ion-select-option
                    value="pink"
                    >Rosa</ion-select-option
                  >
                  <ion-select-option
                    value="black"
                    >Nero</ion-select-option
                  >


                </ion-select>
              </div>
            </div>
            <div class="flex-row" (click)="changeNotify()">
              <div class="flex-1 text-left">
                Notifiche
              </div>
              <div class="flex-1 text-right">
                <ion-toggle [(ngModel)]="notification" (ionChange)="notificationChanged($event)" class="toggle-settings"></ion-toggle>
              </div>
            </div>
            <div class="flex-row" (click)="openModal()">
              <div class="flex-1 text-left">
              Cambia Password
              </div>
              <div class="flex-1 text-right">
               >
              </div>
            </div>


            <div class="flex-row" (click)="openModal()">
              <div class="flex-1 text-left">
                Cambia Password
              </div>
              <div class="flex-1 text-right">
                >
              </div>
            </div>

            <div class="flex-row">
              <ion-button color="danger" (click)="deleteAccount()">Elimina account</ion-button>
            </div>


            <!-- ...a qui -->
          </div>
        </div>
      </div>

      <!-- <div class="floating-btn drop-shadow">+</div> -->
    </ion-content>
  </div>
</div>
